import { DataTableColumnHeader } from "../table-components/data-table-column-header";

export const feedbackAndRatingsColumns = [
  {
    id: "jobRating",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="House Owner Rating" />
    ),
    accessorKey: "jobRating",
    cell: (info) => {
      const rating = info.getValue();
      return rating ? `${rating}/5` : "N/A";
    },
  },
  {
    id: "houseOwnerFeedback",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="House Owner Feedback" />
    ),
    accessorKey: "houseOwnerFeedback",
    cell: (info) => (
      <div className="line-clamp-2 min-w-32">{info.getValue() || "N/A"}</div>
    ),
  },
  {
    id: "jobRatingShoveler",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Shoveller Rating" />
    ),
    accessorKey: "jobRatingShoveler",
    cell: (info) => {
      const rating = info.getValue();
      return rating ? `${rating}/5` : "N/A";
    },
  },
  {
    id: "ShovelerFeedback",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Shoveller Feedback" />
    ),
    accessorKey: "ShovelerFeedback",
    cell: (info) => (
      <div className="line-clamp-2 min-w-32">{info.getValue() || "N/A"}</div>
    ),
  },
];
